import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { changes, fields } from 'src/components/utils/fields'
import { formatDateForInput } from 'src/components/utils/dateFormatter';
import { useMediaQuery } from '@mui/material'
import { BufferService, LoadingContext, M_Button, M_Fieldset, M_Header, M_MessageBoard, NavigateContext, M_Select, M_InputTextField} from 'src/M_Components'
import { GavelOutlined, FeaturedPlayListOutlined, ReceiptOutlined, Refresh, TimerOutlined, AddCircleOutline, DeleteOutline, EditOutlined, RuleOutlined } from '@mui/icons-material'
import { DataTable } from 'primereact/datatable/datatable.cjs.js'
import { Column } from 'primereact/column/column.cjs.js'
import { Dialog } from 'primereact/dialog/dialog.cjs.js'


export const DemurrageRuleCrud = () => {
    const [id, setId] = useState(sessionStorage.getItem('selectedTab'))
    const { t } = useTranslation()
    const ctx = useContext(LoadingContext)
    const ctx2 = useContext(NavigateContext)
    const [data, setData] = useState({})
    const [open, setOpen] = useState(false)
    const [passedRow, setPassedRow] = useState({})
    const [operation, setOperation] = useState(sessionStorage.getItem('operationType') || '')
    const [isFirstTime, setIsFirstTime] = useState(true)
    const [leavingPage, setLeavingPage] = useState(false)
    const [isEditMode, setIsEditMode] = useState(sessionStorage.getItem('operationType') === 'Edit')

    const isAnyOperation = operation || isEditMode || sessionStorage.getItem('operationType')
    const [editingId, setEditingId] = useState(null)

    // Condition sub-grid state
    const [conditions, setConditions] = useState([])
    const [conditionsLoading, setConditionsLoading] = useState(false)
    const [conditionDialogOpen, setConditionDialogOpen] = useState(false)
    const [editingCondition, setEditingCondition] = useState(null)
    const [conditionData, setConditionData] = useState({})
    const [valueOptions, setValueOptions] = useState([])
    const [valueOptionsLoading, setValueOptionsLoading] = useState(false)

    const accountService = new BufferService('Account')
    // const currencyService = new BufferService('Currency')
    // const serviceTypeService = new BufferService('ServiceType')
    const demurrageRuleService = new BufferService('DemurrageRule', 'secondary')
    const demurrageRuleConditionService = new BufferService('DemurrageRuleCondition', 'secondary')

    // Services for condition value dropdowns
    const equipmentTypeService = new BufferService('EquipmentType', 'secondary')
    const equipmentService = new BufferService('Equipment', 'secondary')
    const equipmentClassService = new BufferService('EquipmentClass', 'secondary')
    const locationService = new BufferService('Location')
    const vesselService = new BufferService('Vessel')
    const voyageService = new BufferService('Voyage')
    const bookingService = new BufferService('Booking')
    const transportMeansService = new BufferService('TransportMeans', 'secondary')
    const tradeService = new BufferService('Trade')
    const movementTypeService = new BufferService('MovementType', 'secondary')


    //tenant for incrementing demurrage rule key — to ensure uniqueness per account
    const getUserTenantId = () => localStorage.getItem('userId')

    const sessionKeys = ['operation', 'data', 'open', 'passedRow', 'leavingPage', 'isEditMode', 'editingId', 'conditions']

    const matches = useMediaQuery('(min-width:1800px)')
    const matches2 = useMediaQuery('(min-width:1700px)')
    const matches3 = useMediaQuery('(min-width:1490px)')
    const matches4 = useMediaQuery('(min-width:1450px)')
    const matches5 = useMediaQuery('(min-width:1420px)')
    const matches6 = useMediaQuery('(min-width:1380px)')
    const matches7 = useMediaQuery('(min-width:1280px)')
    const matches8 = useMediaQuery('(min-width:1230px)')
    const matches9 = useMediaQuery('(min-width:1190px)')
    const matches10 = useMediaQuery('(min-width:1150px)')
    const matches11 = useMediaQuery('(min-width:970px)')
    const matches12 = useMediaQuery('(min-width:930px)')
    const matches13 = useMediaQuery('(min-width:850px)')
    const matches14 = useMediaQuery('(min-width:870px)')
    const matches15 = useMediaQuery('(min-width:615px)')
    const matches16 = useMediaQuery('(min-width:440px)')

    const payerOptions = [
        { label: t('Invoice'), value: 'Invoice' },
        { label: t('Client'), value: 'Client' },
        { label: t('Shipper'), value: 'Shipper' },
        { label: t('Consignee'), value: 'Consignee' },
        { label: t('Agent'), value: 'Agent' },
        { label: t('External'), value: 'External' },
        { label: t('Other'), value: 'Other' },
    ]

    const receiptOptions = [
        { label: t('Process'), value: 'C' },
        { label: t('Transport'), value: 'O' },
        { label: t('Voyage'), value: 'V' },
    ]

    const conditionOperatorOptions = [
        { label: 'Equipment Type ID', value: 'EquipmentTypeID' },
        { label: 'Equipment Type Size', value: 'EquipmentTypeSize' },
        { label: 'Agent', value: 'Agent' },
        { label: 'Client', value: 'Client' },
        { label: 'Invoice', value: 'Invoice' },
        { label: 'Shipper', value: 'Shipper' },
        { label: 'Consignee', value: 'Consignee' },
        { label: 'External', value: 'External' },
        { label: 'Owner', value: 'Owner' },
        { label: 'Delivery', value: 'Delivery' },
        { label: 'Pre', value: 'Pre' },
        { label: 'Loading', value: 'Loading' },
        { label: 'Discharge', value: 'Discharge' },
        { label: 'On', value: 'On' },
        { label: 'Receipt', value: 'Receipt' },
        { label: 'From', value: 'From' },
        { label: 'To', value: 'To' },
        { label: 'Transport Means Pick', value: 'TransportMeansPick' },
        { label: 'Transport Means Delivery', value: 'TransportMeansDelivery' },
        { label: 'Merchant Haulage', value: 'MerchantHaulage' },
        { label: 'Move Type A', value: 'MoveTypeA' },
        { label: 'Move Type B', value: 'MoveTypeB' },
        { label: 'Move Type C', value: 'MoveTypeC' },
        { label: 'BL Number', value: 'BLNumber' },
        { label: 'Vessel', value: 'Vessel' },
        { label: 'Voyage', value: 'Voyage' },
        { label: 'Equipment Number', value: 'EquipmentNumber' },
        { label: 'Equipment Class', value: 'EquipmentClass' },
        { label: 'Notify', value: 'Notify' },
        { label: 'Trade Bound', value: 'TradeBound' },
        { label: 'Energy', value: 'Energy' },
    ]

    // Default code per operator — auto-fills Code field when operator is selected
    const operatorDefaultCodeMap = {
        EquipmentTypeID:        'EQUIPMENT_TYPE',
        EquipmentTypeSize:      'EQUIPMENT_TYPE',
        EquipmentNumber:        'EQUIPMENT_NUMBER',
        EquipmentClass:         'EQUIPMENT_TYPE',
        Agent:                  'AGENT',
        Client:                 'CLIENT',
        Invoice:                'INVOICE',
        Shipper:                'SHIPPER',
        Consignee:              'CONSIGNEE',
        Owner:                  'OWNER',
        Delivery:               'DELIVERY',
        MerchantHaulage:        'MERCHANT_HAULAGE',
        Notify:                 'NOTIFY',
        From:                   'FROM',
        To:                     'TO',
        Vessel:                 'VESSEL',
        Voyage:                 'VOYAGE',
        BLNumber:               'BL_NUMBER',
        TransportMeansPick:     'TRANSPORT_MEANS_PICK',
        TransportMeansDelivery: 'TRANSPORT_MEANS_DELIVERY',
        TradeBound:             'TRADE_BOUND',
        External:               'EXTERNAL',
        Pre:                    'PRE',
        Loading:                'LOADING',
        Discharge:              'DISCHARGE',
        On:                     'ON',
        MoveTypeA:              'MOVE_TYPE_A',
        MoveTypeB:              'MOVE_TYPE_B',
        MoveTypeC:              'MOVE_TYPE_C',
        Receipt:                'RECEIPT',
        Energy:                 'ENERGY',
    }

    // Operator to entity mapping - filters removed to avoid OData errors on AccountResultView
    const operatorEntityMap = {
        EquipmentTypeID:        { service: equipmentTypeService,  labelField: 'Code',          valueField: 'Code' },
        EquipmentTypeSize:      { service: equipmentTypeService,  labelField: 'Code',          valueField: 'Code' },
        EquipmentNumber:        { service: equipmentService,      labelFunc: (item) => `${item.Prefix}${item.Number}`, valueFunc: (item) => `${item.Prefix}${item.Number}` },
        EquipmentClass:         { service: equipmentClassService, labelField: 'Code',          valueField: 'Code' },
        Agent:                  { service: accountService,        labelField: 'AccountCode',   valueField: 'AccountCode' },
        Client:                 { service: accountService,        labelField: 'AccountCode',   valueField: 'AccountCode' },
        Invoice:                { service: accountService,        labelField: 'AccountCode',   valueField: 'AccountCode' },
        Shipper:                { service: accountService,        labelField: 'AccountCode',   valueField: 'AccountCode' },
        Consignee:              { service: accountService,        labelField: 'AccountCode',   valueField: 'AccountCode' },
        Owner:                  { service: accountService,        labelField: 'AccountCode',   valueField: 'AccountCode' },
        Delivery:               { service: accountService,        labelField: 'AccountCode',   valueField: 'AccountCode' },
        MerchantHaulage:        { service: accountService,        labelField: 'AccountCode',   valueField: 'AccountCode' },
        Notify:                 { service: accountService,        labelField: 'AccountCode',   valueField: 'AccountCode' },
        From:                   { service: locationService,       labelField: 'LocationCode',  valueField: 'LocationCode' },
        To:                     { service: locationService,       labelField: 'LocationCode',  valueField: 'LocationCode' },
        Vessel:                 { service: vesselService,         labelField: 'Code',          valueField: 'Code' },
        Voyage:                 { service: voyageService,         labelField: 'VoyageNumber',  valueField: 'VoyageNumber' },
        BLNumber:               { service: bookingService,        labelField: 'BookingNumber', valueField: 'BookingNumber' },
        TransportMeansPick:     { service: transportMeansService, labelField: 'Code',          valueField: 'Code' },
        TransportMeansDelivery: { service: transportMeansService, labelField: 'Code',          valueField: 'Code' },
        TradeBound:             { service: tradeService,          labelField: 'TradeCode',     valueField: 'TradeCode' },
        External:               { service: movementTypeService,   labelField: 'Code',          valueField: 'Code' },
        Pre:                    { service: movementTypeService,   labelField: 'Code',          valueField: 'Code' },
        Loading:                { service: movementTypeService,   labelField: 'Code',          valueField: 'Code' },
        Discharge:              { service: movementTypeService,   labelField: 'Code',          valueField: 'Code' },
        On:                     { service: movementTypeService,   labelField: 'Code',          valueField: 'Code' },
        MoveTypeA:              { service: movementTypeService,   labelField: 'Code',          valueField: 'Code' },
        MoveTypeB:              { service: movementTypeService,   labelField: 'Code',          valueField: 'Code' },
        MoveTypeC:              { service: movementTypeService,   labelField: 'Code',          valueField: 'Code' },
        Receipt:                { static: receiptOptions },
        Energy:                 { freeText: true },
    }

    const loadValueOptions = (operator) => {
        if (!operator) { setValueOptions([]); return }
        const mapping = operatorEntityMap[operator]
        if (!mapping) { setValueOptions([]); return }
        if (mapping.static) { setValueOptions(mapping.static); return }
        if (mapping.freeText) { setValueOptions([]); return }

        setValueOptionsLoading(true)
        ctx.setIsLoad(true)

        const request = mapping.filter 
            ? mapping.service.filter(mapping.filter)
            : mapping.service.get()

        request.then(response => {
            setValueOptionsLoading(false)
            ctx.setIsLoad(false)
            
            if (response?.name === 'AxiosError') {
                ctx.toastMessages('error', '', t('Failed to load value options'))
                return
            }

            // Handle both OData response { Items: [...] } and direct array [...]
            const items = response?.Items || (Array.isArray(response) ? response : [])
            
            const options = items.map(item => ({
                label: mapping.labelFunc ? mapping.labelFunc(item) : item[mapping.labelField],
                value: mapping.valueFunc ? mapping.valueFunc(item) : item[mapping.valueField],
            })).filter(opt => opt.label && opt.value)

            setValueOptions(options)
        }).catch(() => {
            setValueOptionsLoading(false)
            ctx.setIsLoad(false)
            ctx.toastMessages('error', '', t('Failed to load value options'))
        })
    }

    // Fields
    const DemurrageRuleFields = [
        { 
            display: t('Account ID'), 
            required: true, 
            code: 'accountID', 
            type: 'foreignKey', 
            entity: 'Account', 
            filterField: 'AccountCode', 
            labelFields: ['AccountCode'], 
            fields: [{ key: 'AccountCode', value: 'accountID' }, { key: 'Id', value: 'accountId' }, { key: 'TenantId', value: 'accountTenantId' }],
            returnFunc: async (data, field, obj) => {
                const newData = { ...data }
                field.fields?.forEach(keyValue => {
                    newData[keyValue.value] = obj && obj[keyValue.key] || ''
                })

                const accId = obj?.Id || obj?.id
                if (accId) {
                    newData.accountTenantId = getUserTenantId()
                    const nextKey = await getNextDemuKey()
                    newData.demuKey = nextKey.toString()
                }
                setData(newData)
            }
        },
            { display: t('Demu Key'), required: true, code: 'demuKey', type: 'number', disabled: true },
            { display: t('StartDate'), required: true, code: 'startDate', type: 'date' },
            { display: t('ExpireDate'), code: 'expireDate', type: 'date' },
            // { display: t('Rule Currency'), required: true, code: 'currency', type: 'foreignKey', entity: 'Currency', filterField: 'Code', labelFields: ['Code'], fields: [{ key: 'Code', value: 'currency' }, { key: 'Id', value: 'currencyId' }] },
            { display: t('Cost Currency'), required: false, code: 'costCurrency', type: 'foreignKey', entity: 'Currency', filterField: 'Code', labelFields: ['Code'], fields: [{ key: 'Code', value: 'costCurrency' }, { key: 'Id', value: 'costCurrencyId' }] },
            { display: t('Weekend'), type: 'checkBox', code: 'weekend' },
            { type: 'separator' },
            { display: t('Description'), code: 'ruleDescription', required: true, type: 'textArea', fullWidth: true },
            { display: t('Comments'), code: 'conditionComments', type: 'textArea', fullWidth: true },
    ]
        const DemurrageFields = [   // ← was ConditionsFields
        { display: t('Free Days'), code: 'freeDays', type: 'number' },
        { display: t('1st Days'), code: 'firstDays', type: 'number' },
        { display: t('2nd Days'), code: 'secondDays', type: 'number' },
        { display: t('3rd Days'), code: 'thirdDays', type: 'number' },
        { display: t('1st Price'), code: 'firstPrice', type: 'decimal' },
        { display: t('2nd Price'), code: 'secondPrice', type: 'decimal' },
        { display: t('3rd Price'), code: 'thirdPrice', type: 'decimal' },
        { display: t('Last Price'), code: 'lastPrice', type: 'decimal' },
    ]
    const TerminalFields = [
        { display: t('Terminal Free'), code: 'terminalFree', type: 'number' },
        { display: t('Terminal Days')+' '+'1', code: 'terminalDays1', type: 'number' },
        { display: t('Terminal Days')+' '+'2', code: 'terminalDays2', type: 'number' },
        { display: t('Terminal Days')+' '+'3', code: 'terminalDays3', type: 'number' },
        { display: t('Terminal Cost')+' '+'1', code: 'terminalCost1', type: 'decimal' },
        { display: t('Terminal Cost')+' '+'2', code: 'terminalCost2', type: 'decimal' },
        { display: t('Terminal Cost')+' '+'3', code: 'terminalCost3', type: 'decimal' },
        { display: t('Terminal Price')+' '+'1', code: 'terminalPrice1', type: 'decimal' },
        { display: t('Terminal Price')+' '+'2', code: 'terminalPrice2', type: 'decimal' },
    ]
    const InvoiceFields = [
        { display: t('Payer'), required: true, code: 'payer', type: 'select', options: 'payerOptions', extraField: 'payerValue' },
        { display: t('Client Code'), required: false, code: 'clientCode', type: 'foreignKey', entity: 'Account', filterField: 'AccountCode', labelFields: ['AccountCode'], fields: [{ key: 'AccountCode', value: 'clientCode' }, { key: 'Id', value: 'clientCodeId' }] },
        { display: t('Agent Commission'), code: 'agentCommission', type: 'number' },
        { display: t('Pay Currency'), required: true, code: 'invoiceCurrency', type: 'foreignKey', entity: 'Currency', filterField: 'Code', labelFields: ['Code'], fields: [{ key: 'Code', value: 'invoiceCurrency' }, { key: 'Id', value: 'invoiceCurrencyId' }] },
        { display: t('ServiceCode'), required: true, code: 'serviceTypeCode', type: 'foreignKey', entity: 'ServiceType', filterField: 'ServiceCode', labelFields: ['ServiceCode'], fields: [{ key: 'ServiceCode', value: 'serviceTypeCode' }, { key: 'Id', value: 'serviceTypeId' }] },
        //{ display: t('Exchange'), required: false, code: 'exchange', type: 'text' },
        { display: t('Demu Order'), required: true, code: 'demuOrder', type: 'number' },
    ]

    useEffect(() => {
        if (isFirstTime) {
            ctx.setIsLoad(true)
            getSessionStorageData(id)
            setIsFirstTime(false)
            sessionStorage.setItem(`tab${id}`, JSON.stringify(sessionKeys))

            const editingDemurrageRule = JSON.parse(sessionStorage.getItem('editingDemurrageRule'))
            const operationType = sessionStorage.getItem('operationType')

            if (editingDemurrageRule && (operationType === 'Edit' || operationType === 'Copy')) {
                editOrCopyDemurrageRule(editingDemurrageRule.Id, operationType === 'Copy')
                sessionStorage.removeItem('editingDemurrageRule')
                sessionStorage.removeItem('operationType')
            } else if (operationType === 'Create') {
                setOperation('Create')
            }
        }
    }, [])

    useEffect(() => {
        const newId = sessionStorage.getItem('selectedTab')
        if (newId !== id) {
            setId(newId)
            getSessionStorageData(newId)
        }
    })

    useEffect(() => {
        sessionKeys.forEach((key) => {
            sessionStorageMachine(id, key, key)
        })
        // eslint-disable-next-line
    }, [id, operation, data, leavingPage, isEditMode, editingId, conditions])

    const sessionStorageMachine = (id, key, value) => {
        if (eval(value) instanceof Object && Object.keys(eval(value)).length === 0) return
        if (eval(value) instanceof String && eval(value) === '') return
        if (eval(value) instanceof Number && eval(value) === '') return
        // eslint-disable-next-line
        if (eval(value) instanceof Map) {
            // eslint-disable-next-line
            sessionStorage.setItem(`${id}${key}`, JSON.stringify(Array.from(eval(value))))
        } else {
            // eslint-disable-next-line
            sessionStorage.setItem(`${id}${key}`, JSON.stringify(eval(value)))
        }
    }

    const getSessionStorageData = (sessionID) => {
        ctx.setIsLoad(true)
        const tempO = JSON.parse(sessionStorage.getItem(`${sessionID}operation`))
        const tempD = JSON.parse(sessionStorage.getItem(`${sessionID}data`))
        const tempOS = JSON.parse(sessionStorage.getItem(`${sessionID}open`))
        const tempPR = JSON.parse(sessionStorage.getItem(`${sessionID}passedRow`))
        const tempLP = JSON.parse(sessionStorage.getItem(`${sessionID}leavingPage`))
        const tempEM = JSON.parse(sessionStorage.getItem(`${sessionID}isEditMode`))
        const tempEID = JSON.parse(sessionStorage.getItem(`${sessionID}editingId`))
        const tempC = JSON.parse(sessionStorage.getItem(`${sessionID}conditions`))

        if ((tempO && tempO !== '') || (tempD && Object.keys(tempD).length !== 0) || tempOS || (tempPR && Object.keys(tempD).length !== 0)) {
            setOperation(tempO ? String(tempO) : '')
            setData(tempD ? { ...tempD } : {})
            setOpen(tempOS)
            setPassedRow(tempPR)
            setLeavingPage(tempLP || false)
            setIsEditMode(tempEM || false)
            setEditingId(tempEID || null)
            setConditions(tempC || [])
            ctx.setIsLoad(false)
            return
        }
        get()
    }

    const get = () => {
        ctx.setIsLoad(false)
    }

    const refreshDemurrageRule = () => {
        ctx.setIsLoad(true)
        sessionKeys.forEach(key => {
            sessionStorage.removeItem(`${id}${key}`)
        })
        setData({})
        setPassedRow({})
        setOpen(false)
        setOperation('')
        setLeavingPage(false)
        setIsEditMode(false)
        setEditingId(null)
        setConditions([])
        get()
        ctx.setIsLoad(false)
        ctx.toastMessages('success', t('Form refreshed'), '')
    }

    // ─── Condition sub-grid functions ─────────────────────────────────────────

    const loadConditions = (ruleId) => {
        if (!ruleId) return
        setConditionsLoading(true)
        demurrageRuleConditionService.filter(`/query?filter=DemurrageRuleId eq ${ruleId}`)
            .then(response => {
                setConditionsLoading(false)
                if (response?.name === 'AxiosError') {
                    ctx.toastMessages('error', '', t('Failed to load conditions'))
                    return
                }
                setConditions(response?.Items ?? [])
            })
            .catch(() => {
                setConditionsLoading(false)
                ctx.toastMessages('error', '', t('Failed to load conditions'))
            })
    }

    const openConditionDialog = (condition = null) => {
        setEditingCondition(condition)
        setConditionData(condition
            ? {
                value: condition.Value,
                operator: condition.DemurrageConditionOperator,
            }
            : {}
        )
        if (condition?.DemurrageConditionOperator) {
            loadValueOptions(condition.DemurrageConditionOperator)
        } else {
            setValueOptions([])
        }
        setConditionDialogOpen(true)
    }

    const closeConditionDialog = () => {
        setConditionDialogOpen(false)
        setEditingCondition(null)
        setConditionData({})
        setValueOptions([])
    }

    const saveCondition = async () => {
    if (!conditionData.value || !conditionData.operator) {
        ctx.toastMessages('error', '', t('Missing required fields'))
        return
    }

    if (!editingId) {
        // Store locally until rule is saved
        if (editingCondition) {
            setConditions(prev => prev.map(c => c === editingCondition
                ? { Code: conditionData.value, Value: conditionData.value, DemurrageConditionOperator: conditionData.operator }
                : c
            ))
        } else {
            setConditions(prev => [...prev, {
                Code: conditionData.value,
                Value: conditionData.value,
                DemurrageConditionOperator: conditionData.operator,
            }])
        }
        closeConditionDialog()
        return
    }

    // Edit mode — save to API
    const conditionBody = {
        Code: conditionData.value,
        Value: conditionData.value,
        DemurrageConditionOperator: conditionData.operator,
        DemurrageRuleId: editingId,
    }

    ctx.setIsLoad(true)
    const promise = editingCondition
        ? demurrageRuleConditionService.update(editingCondition.Id, conditionBody)
        : demurrageRuleConditionService.post(conditionBody)

    promise.then(response => {
        ctx.setIsLoad(false)
        if (response?.name === 'AxiosError') {
            ctx.toastMessages('error', '', t('Failed to save condition'))
            return
        }
        ctx.toastMessages('success', '', editingCondition ? t('Condition updated successfully') : t('Condition saved successfully'))
        closeConditionDialog()
        loadConditions(editingId)
    }).catch(() => {
        ctx.setIsLoad(false)
        ctx.toastMessages('error', '', t('Failed to save condition'))
    })
    }

    const deleteCondition = async (condition) => {
        ctx.setIsLoad(true)
        if (!condition.Id) {
            setConditions(prev => prev.filter(c => c !== condition))
            return
        }
        const response = await demurrageRuleConditionService.delete(condition.Id)
        ctx.setIsLoad(false)
        if (response?.name === 'AxiosError') {
            ctx.toastMessages('error', '', t('Failed to delete condition'))
            return
        }
        ctx.toastMessages('success', '', t('Condition deleted successfully'))
        loadConditions(editingId)
    }

    // ──────────────────────────────────────────────────────────────────────────

    const checkDemurrageRuleExists = async (accountId, key, excludeId = null) => {
        if (!accountId || !key) return false
        try {
            const response = await demurrageRuleService.filter(`?filter=AccountID eq ${accountId}`)
            if (response.name === 'AxiosError' || !response.Items) return false
            const matchingItems = response.Items.filter(item => item.Key === key)
            if (excludeId) {
                return matchingItems.filter(item => item.Id !== excludeId).length > 0
            }
            return matchingItems.length > 0
        } catch (error) {
            console.error('Error checking demurrage rule:', error)
            return false
        }
    }
 
    const getNextDemuKey = async () => {
        try {
            const tenantId = getUserTenantId()
            if (!tenantId) return 1

            const rulesRes = await demurrageRuleService.filter(`?filter=AccountTenantId eq ${tenantId}`)
            if (rulesRes?.name === 'AxiosError' || !rulesRes?.Items?.length) return 1

            const allKeys = rulesRes.Items
                .map(item => parseInt(item.Key ?? item.key))
                .filter(k => !isNaN(k))

            return allKeys.length ? Math.max(...allKeys) + 1 : 1
        } catch (error) {
            console.error('[getNextDemuKey] Error:', error)
            return 1
        }
    }

    const onSave = async () => {

        console.log('[onSave] current data state:', data)
        console.log('[onSave] accountTenantId being sent:', data.accountTenantId)
        console.log('[onSave] isEditMode:', isEditMode, '| editingId:', editingId)
        if (!data.accountId || !data.demuKey || !data.ruleDescription) {
            ctx.toastMessages('error', '', t('Missing required fields'))
            return
        }

        let checkDuplicate = false
        if (!isEditMode) {
            checkDuplicate = true
        } else {
            const accountChanged = data.accountId !== data._originalAccountId
            const keyChanged = parseInt(data.demuKey) !== parseInt(data._originalKey)
            if (accountChanged || keyChanged) checkDuplicate = true
        }

        if (checkDuplicate) {
            ctx.setIsLoad(true)
            const exists = await checkDemurrageRuleExists(data.accountId, parseInt(data.demuKey), editingId)
            ctx.setIsLoad(false)
            if (exists) {
                ctx.toastMessages('error', '', `${t('Demurrage Rule')} ${data.accountID} ${data.demuKey} ${t('already exists!')}`)
                return
            }
        }

        const expireDate = data.expireDate ? new Date(data.expireDate) : null
        const startDate = data.startDate ? new Date(data.startDate) : null
        if (expireDate && startDate && expireDate <= startDate) {
            ctx.toastMessages('error', '', t('Expire date must be after Start date'))
            return
        }

        const demurrageRuleData = {
            AccountID: data.accountId,
            AccountTenantId: data.accountTenantId,
            Key: parseInt(data.demuKey),
            Description: data.ruleDescription,
            Order: parseInt(data.demuOrder),
            StartDate: data.startDate,
            ExpirationDate: data.expireDate || null,
            Payer: data.payerValue,
            ClientID: data.clientCodeId,
            ClientName: data.clientCode,
            TerminalFreeNumber: parseInt(data.terminalFree) || 0,
            TerminalFirstDays: parseInt(data.terminalDays1) || 0,
            TerminalFirstDaysCost: parseFloat(data.terminalCost1) || 0,
            TerminalFirstDaysPrice: parseFloat(data.terminalPrice1) || 0,
            TerminalSecondDays: parseInt(data.terminalDays2) || 0,
            TerminalSecondDaysCost: parseFloat(data.terminalCost2) || 0,
            TerminalSecondDaysPrice: parseFloat(data.terminalPrice2) || 0,
            TerminalThirdDays: parseInt(data.terminalDays3) || 0,
            TerminalThirdDaysCost: parseFloat(data.terminalCost3) || 0,
            TerminalThirdDaysPrice: parseFloat(data.terminalPrice3) || 0,
            TerminalFinalDaysCost: 0,
            TerminalFinalDaysPrice: parseFloat(data.terminalPrice3) || 0,
            CurrencyId: data.costCurrencyId,
            CurrencyCode: data.costCurrency,  
            AgentComission: parseFloat(data.agentCommission) || 0,
            AgentComissionMultiple: null,
            FreeNumber: parseInt(data.freeDays) || 0,
            FirstPeriodNumber: parseInt(data.firstDays) || 0,
            SecondPeriodNumber: parseInt(data.secondDays) || 0,
            ThirdPeriodNumber: parseInt(data.thirdDays) || 0,
            FirstPeriodPrice: parseFloat(data.firstPrice) || 0,
            SecondPeriodPrice: parseFloat(data.secondPrice) || 0,
            ThirdPeriodPrice: parseFloat(data.thirdPrice) || 0,
            LastPeriodPrice: parseFloat(data.lastPrice) || 0,
            PayCurrencyCode: data.invoiceCurrency,
            PayCurrencyId: data.invoiceCurrencyId,
            Exchange: data.exchange || '',
            ServiceTypeId: data.serviceTypeId || null,
            ServiceTypeCode: data.serviceTypeCode || null,
            Comments: data.conditionComments || '',
            Weekend: data.weekend || false
        }
        console.log('[onSave] demurrageRuleData payload:', demurrageRuleData)

        ctx.setIsLoad(true)
        const savePromise = isEditMode && editingId
            ? demurrageRuleService.update(editingId, demurrageRuleData)
            : demurrageRuleService.post(demurrageRuleData)

        savePromise.then(async response => {
            ctx.setIsLoad(false)
            if (response.name === 'AxiosError') {
                handleError(response)
                return
            }

            if (!isEditMode && response?.Id && conditions.length > 0) {
                console.log('conditions to save:', conditions)
                ctx.setIsLoad(true)
                await Promise.all(conditions.map(c =>
                    demurrageRuleConditionService.post({
                        Code: c.Value,
                        Value: c.Value,
                        DemurrageConditionOperator: c.DemurrageConditionOperator,
                        DemurrageRuleId: response.Id,
                    })
                ))
                ctx.setIsLoad(false)
            }

            ctx.toastMessages('success', '', isEditMode
                ? `${t('DemurrageRule')} ${t('updatedSuccessfully')}`
                : `${t('DemurrageRule')} ${t('savedSuccessfully')}`)
            ctx2.closeTab(JSON.parse(id))
        }).catch(error => {
            ctx.setIsLoad(false)
            handleError(error)
        })
    }

    const editOrCopyDemurrageRule = (demurrageRuleId, isCopy = false) => {
        ctx.setIsLoad(true)
        demurrageRuleService.getId(demurrageRuleId).then(async response => {
            if (response.name === 'AxiosError') {
                ctx.setIsLoad(false)
                ctx.toastMessages('error', '', `${t('DemurrageRule')} ${t('Failed to load')}`)
                return
            }

            const demurrageRuleData = {
                accountId: response.AccountID?.toString(),
                accountTenantId: response.AccountTenantId || '',
                _originalAccountId: response.AccountID?.toString(),
                demuKey: response.Key.toString(),
                _originalKey: response.Key.toString(),
                ruleDescription: response.Description,
                demuOrder: response.Order?.toString(),
                startDate: response.StartDate?.split('T')[0],
                expireDate: response.ExpirationDate?.split('T')[0] || '',
                payer: response.Payer,
                payerValue: response.Payer,
                clientCodeId: response.ClientID?.toString(),
                terminalFree: response.TerminalFreeNumber?.toString() || '0',
                terminalDays1: response.TerminalFirstDays?.toString() || '0',
                terminalCost1: response.TerminalFirstDaysCost?.toString() || '0',
                terminalPrice1: response.TerminalFirstDaysPrice?.toString() || '0',
                terminalDays2: response.TerminalSecondDays?.toString() || '0',
                terminalCost2: response.TerminalSecondDaysCost?.toString() || '0',
                terminalPrice2: response.TerminalSecondDaysPrice?.toString() || '0',
                terminalDays3: response.TerminalThirdDays?.toString() || '0',
                terminalCost3: response.TerminalThirdDaysCost?.toString() || '0',
                terminalPrice3: response.TerminalThirdDaysPrice?.toString() || response.TerminalFinalDaysPrice?.toString() || '0',
                costCurrencyId: (response.CurrencyID || response.CurrencyId)?.toString() || '',
                costCurrency: response.CurrencyCode || '',
                agentCommission: response.AgentComission?.toString() || '',
                freeDays: response.FreeNumber?.toString() || '0',
                firstDays: response.FirstPeriodNumber?.toString() || '0',
                secondDays: response.SecondPeriodNumber?.toString() || '0',
                thirdDays: response.ThirdPeriodNumber?.toString() || '0',
                firstPrice: response.FirstPeriodPrice?.toString() || '0',
                secondPrice: response.SecondPeriodPrice?.toString() || '0',
                thirdPrice: response.ThirdPeriodPrice?.toString() || '0',
                lastPrice: response.LastPeriodPrice?.toString() || '0',
                invoiceCurrency: response.PayCurrencyCode,
                invoiceCurrencyId: (response.PayCurrencyID || response.PayCurrencyId)?.toString() || '',
                exchange: response.Exchange || '',
                serviceTypeCode: response.ServiceTypeCode || '',
                serviceTypeId: response.ServiceTypeId || '',
                conditionComments: response.Comments || '',
                weekend: response.Weekend || false,
                _isCopy: isCopy,
                _originalId: isCopy ? demurrageRuleId : null
            }
             console.log('[editOrCopy] loaded rule response:', response)
            console.log('[editOrCopy] AccountTenantId from rule:', response.AccountTenantId)
            console.log('[editOrCopy] isCopy:', isCopy)

            const timeout = setTimeout(() => ctx.setIsLoad(false), 10000)
            const secondaryFetches = []

            if (response.AccountID) {
                secondaryFetches.push(
                    accountService.getId(response.AccountID).then(accountRes => {
                        if (accountRes.name !== 'AxiosError') {
                            demurrageRuleData.accountID = accountRes.AccountCode
                        }
                    })
                )
            }
            if (response.ClientID) {
                secondaryFetches.push(
                    accountService.getId(response.ClientID).then(clientRes => {
                        if (clientRes.name !== 'AxiosError') {
                            demurrageRuleData.clientCode = clientRes.AccountCode
                        }
                    })
                )
            }
            // if (response.CurrencyID && response.CurrencyID.length > 20) {
            //     secondaryFetches.push(
            //         currencyService.getId(response.CurrencyID).then(currencyRes => {
            //             if (currencyRes && currencyRes.name !== 'AxiosError') {
            //                 demurrageRuleData.currency = currencyRes.Id
            //                 demurrageRuleData.invoiceCurrency = currencyRes.Code
            //             }
            //         }).catch(() => {})
            //     )
            // }
            

            await Promise.all(secondaryFetches)

            if (isCopy) {
                delete demurrageRuleData.Id
                delete demurrageRuleData.ExternalId
                delete demurrageRuleData.CreatedAt
                delete demurrageRuleData.UpdatedAt
                setIsEditMode(false)
                setEditingId(null)
                setOperation('Copy')
                setConditions([])

                // Auto-increment Demu Key on copy
                const nextKey = await getNextDemuKey(response.AccountID)
                demurrageRuleData.demuKey = nextKey.toString()
            } else {
                setIsEditMode(true)
                setEditingId(demurrageRuleId)
                setOperation('Edit')
                loadConditions(demurrageRuleId)
            }

            setData(demurrageRuleData)
            console.log('[editOrCopy] final demurrageRuleData set:', demurrageRuleData)
            clearTimeout(timeout)
            ctx.setIsLoad(false)

        }).catch(error => {
            ctx.setIsLoad(false)
            console.error('Error loading demurrage rule:', error)
            ctx.toastMessages('error', '', `${t('DemurrageRule')} ${t('Failed to load')}`)
        })
    }

    const handleError = (error) => {
        let errorMessage = 'Error saving demurrage rule'
        const data = error.response?.data
        if (Array.isArray(data)) {
            errorMessage = data.map(e => `${e.field}: ${e.message}`).join('\n')
        } else if (data?.errors) {
            errorMessage = Object.entries(data.errors)
                .map(([field, messages]) => `${field}: ${messages.join(', ')}`)
                .join('; ')
        } else if (data?.message) {
            errorMessage = data.field ? `${data.field}: ${data.message}` : data.message
        } else if (data?.title) {
            errorMessage = data.title
        } else if (error.message) {
            errorMessage = error.message
        }
        ctx.toastMessages('error', '', errorMessage)
    }
    
    return (
        <div>
            <M_Header
                element={
                    <>
                        <M_Button
                            tooltip={t("Back")}
                            label={t("Back")}
                            icon={<i className="pi pi-arrow-left iconTable" style={{ width: '20px', color: ctx.secondaryColor ? ctx.secondaryColor : 'var(--color-black)' }}></i>}
                            onClick={() => { setLeavingPage(true) }}
                        />
                        <M_Button
                            tooltip={t("Refresh")}
                            icon={<Refresh />}
                            label={t("Refresh")}
                            onClick={() => refreshDemurrageRule()}
                        />
                        <M_Button
                            tooltip={t("Save")}
                            icon={<i className="pi pi-save"></i>}
                            label={t("Save")}
                            onClick={() => onSave()}
                        />
                    </>
                }
            />
            <div style={{ margin: '20px' }}>
                <div style={{ display: 'grid', gridTemplateColumns: 'auto' }}>
                    <M_Fieldset
                        labelInside
                        label={<div style={{ display: 'flex', alignItems: 'center', fontSize: '25px', marginLeft: '10px' }}><GavelOutlined style={{ marginRight: '10px', scale: '1.3' }} /> {t("DemurrageRule")}</div>}
                        elements={
                            <div style={{ display: 'grid', gridTemplateColumns: !matches15 && 'auto' || !matches13 && 'auto auto' || 'auto auto auto', justifyContent: 'space-evenly' }}>
                                {DemurrageRuleFields.map((field, index) => {
                                    if (field.type === 'separator') return <div key={`separator-${index}`} style={{ gridColumn: '1 / -1', height: '0' }} />
                                    if (field.fullWidth) return (
                                        <div key={index} style={{ gridColumn: '1 / -1', width: '100%', marginTop: '10px' }}>
                                            {fields(field, index, data, setData, false, field.returnFunc || null, '100%')}
                                        </div>
                                    )
                                    return fields(field, index, data, setData, null, field.returnFunc || null)
                                })}
                            </div>
                        }
                    />
                </div>

                <div style={{ display: 'grid', gridTemplateColumns: !matches10 && 'auto' || 'auto auto' }}>
                    <M_Fieldset
                        labelInside
                        label={<div style={{ display: 'flex', alignItems: 'center', fontSize: '25px', marginLeft: '10px' }}><TimerOutlined style={{ marginRight: '10px', scale: '1.3' }} /> {t("Terminal")}</div>}
                        elements={
                            <div style={{ display: 'grid', gridTemplateColumns: !matches15 && 'auto' || !matches6 && 'auto auto' || 'auto auto auto', justifyContent: 'space-evenly' }}>
                                {TerminalFields.map((field, index) => fields(field, index, data, setData, null, null))}
                            </div>
                        }
                    />
                    <M_Fieldset
                        labelInside
                        label={<div style={{ display: 'flex', alignItems: 'center', fontSize: '25px', marginLeft: '10px' }}><FeaturedPlayListOutlined style={{ marginRight: '10px', scale: '1.3' }} /> {t("Demurrage")}</div>}
                        elements={
                            <div style={{ display: 'grid', gridTemplateColumns: !matches15 && 'auto' || !matches6 && 'auto auto' || 'auto auto auto', justifyContent: 'space-evenly' }}>
                                {DemurrageFields.map((field, index) => {
                                    if (field.type === 'separator') return <div key={`separator-${index}`} style={{ gridColumn: '1 / -1', height: '0' }} />
                                    if (field.fullWidth) return (
                                        <div key={index} style={{ gridColumn: '1 / -1', width: '100%', marginTop: '10px' }}>
                                            {fields(field, index, data, setData, false, null, '100%')}
                                        </div>
                                    )
                                    return fields(field, index, data, setData, null, field.returnFunc)
                                })}
                            </div>
                        }
                    />
                </div>

                <div style={{ display: 'grid', gridTemplateColumns: 'auto' }}>
                    <M_Fieldset
                        labelInside
                        label={<div style={{ display: 'flex', alignItems: 'center', fontSize: '25px', marginLeft: '10px' }}><ReceiptOutlined style={{ marginRight: '10px', scale: '1.3' }} /> {t("Invoice")}</div>}
                        elements={
                            <div style={{ display: 'grid', gridTemplateColumns: !matches15 && 'auto' || !matches13 && 'auto auto' || !matches9 && 'auto auto auto' || 'auto auto auto auto', justifyContent: 'space-evenly' }}>
                                {InvoiceFields.map((field, index) => fields(field, index, data, setData, null, null, '250px', payerOptions))}
                            </div>
                        }
                    />
                </div>

                
                    <div style={{ margin: '20px 0' }}>
                        <div style={{ border: '1px solid #dee2e6', borderRadius: '8px', overflow: 'hidden', boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}>
                            <div style={{ padding: '12px 16px', backgroundColor: '#f8f9fa', borderBottom: '1px solid #dee2e6', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                <span style={{ display: 'flex', alignItems: 'center', fontWeight: 600, fontSize: '1rem' }}>
                                    <RuleOutlined style={{ marginRight: '8px' }} />
                                    {t('Rule Conditions')}
                                </span>
                                <M_Button
                                    tooltip={!editingId ? t('Save the rule first to add conditions') : t('Add Condition')}
                                    label={t('Add Condition')}
                                    icon={<AddCircleOutline />}
                                    onClick={() => openConditionDialog()}         
                                />
                            </div>
                            {conditionsLoading ? (
                                <div style={{ padding: '24px', textAlign: 'center', color: '#6c757d' }}>{t('Loading')}...</div>
                            ) : (
                                <DataTable value={conditions} size="small" stripedRows emptyMessage={t('No conditions defined for this rule')} style={{ fontSize: '0.875rem' }}>
                                    <Column field="DemurrageConditionOperator" header={t('Operator')} />
                                    <Column field="Value" header={t('Value')} />
                                    <Column
                                        header={t('Actions')}
                                        style={{ width: '90px' }}
                                        body={(row) => (
                                            <span style={{ display: 'flex', gap: '8px' }}>
                                                <EditOutlined style={{ cursor: 'pointer', color: '#495057' }} onClick={() => openConditionDialog(row)} />
                                                <DeleteOutline style={{ cursor: 'pointer', color: '#dc3545' }} onClick={() => deleteCondition(row)} />
                                            </span>
                                        )}
                                    />
                                </DataTable>
                            )}
                        </div>
                    </div>
                

                <div style={{ height: '150px' }}></div>
            </div>

            <Dialog
                visible={conditionDialogOpen}
                onHide={closeConditionDialog}
                header={editingCondition ? t('Edit Condition') : t('Add Condition')}
                style={{ width: '400px' }}
                footer={
                    <span style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
                        <M_Button label={t('ButtonCancel')} onClick={closeConditionDialog} />
                        <M_Button label={t('Save')} onClick={saveCondition} />
                    </span>
                }
            >
                <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', padding: '8px 0' }}>

                    {/* Operator */}
                    <div>
                        <M_Select
                            autocomplete
                            label={t('Operator')}
                            value={conditionOperatorOptions.find(opt => opt.value === conditionData.operator) || conditionData.operator || ''}
                            options={conditionOperatorOptions}
                            onChangeValue={val => {
                                 const newOperator = val?.value !== undefined ? val.value : val;
                                 setConditionData(prev => ({
                                     ...prev,
                                     operator: newOperator,
                                     value: '',
                                     // Remove auto-fill of code, user will type it
                                     code: prev.code || ''
                                 }))
                                 loadValueOptions(newOperator)
                             }}
                             onChange={() => {}}
                             hasNone={false}
                        />
                    </div>

                    {/* Value — dropdown or free text depending on operator */}
                    <div>
                        {!conditionData.operator || operatorEntityMap[conditionData.operator]?.freeText ? (
                            <M_InputTextField
                                label={t('Value')}
                                value={conditionData.value || ''}
                                onChange={e => setConditionData(prev => ({ ...prev, value: e.target.value }))}
                                fullWidth
                            />
                        ) : valueOptionsLoading ? (
                            <div style={{ padding: '8px', color: '#6c757d' }}>{t('Loading')}...</div>
                        ) : (
                            <M_Select
                                autocomplete
                                value={valueOptions.find(opt => opt.value === conditionData.value) || conditionData.value || ''}
                                options={valueOptions}
                                onChangeValue={(val) => {
                                     const actualValue = val?.value !== undefined ? val.value : val;
                                     setConditionData(prev => ({ ...prev, value: actualValue }))
                                 }}
                                 onChange={() => {}}
                                 label={t('Value')}
                                translate={false}
                                hasNone={true}
                            />
                        )}
                    </div>
                </div>
            </Dialog>

            <M_MessageBoard
                warning
                open={leavingPage}
                title={t("leavingPageTitle")}
                body={t("leavingPageBody")}
                footer={
                    <span style={{ display: 'flex', alignItems: 'center' }}>
                        <M_Button hoverEffect normal labelColor={'white'} backgroundColor={'var(--color-red)'} onClick={() => setLeavingPage(false)} label={t("ButtonCancel")} />
                        <M_Button hoverEffect normal labelColor={'white'} backgroundColor={'var(--color-green)'} onClick={() => ctx2.closeTab(JSON.parse(id))} label={t("ButtonConfirm")} />
                    </span>
                }
            />
        </div>
    )
}